<section
  [style.min-width]="minWidth"
  #sectionRef
  id="dropdown-trigger-{{ elementId }}"
  [class]="'frontend-dropdown background-hover border-border not-plain ' + customClass"
  (keyup)="deleteLastItem($event)"
  (click)="presentDropdown()"
>
  <div class="left-part" [style.max-width.px]="sectionRef.offsetWidth - 32">
    <ng-container *ngIf="value?.length > 0">
      <ion-chip
        mode="ios"
        *ngFor="let itemId of value"
        [class.readonly]="disabled"
        [class.clearable]="multiple && !disabled"
        [class.clear-chip]="!multiple"
      >
        <tr-icon
          *ngIf="multiple && !disabled"
          (click)="noBubble($event); checkboxChange(itemId, { checked: false })"
          [size]="iconSize.small"
          [icon]="icon.cancel"
          class="tr-icon border-hover"
        ></tr-icon>

        <div>
          <ion-label *ngIf="customName" [innerHTML]="customName(itemsIdToItemMap[itemId])"></ion-label>
          <ion-label *ngIf="!customName" [innerHTML]="itemsIdToLabelMap[itemId]"></ion-label>
        </div>
      </ion-chip>
    </ng-container>

    <div
      class="position-relative"
      [class.placeholder-wrapper]="(multiple || (addTag && value?.length === 0))"
    >
      <p class="placeholder" *ngIf="searchString === '' && (multiple || (!multiple && value?.length === 0))">{{ placeholder }}</p>

      <ion-input
        mode="ios"
        #searchField
        [readonly]="isMobileDevice || !searchable"
        class="search-input"
        inputmode="text"
        autocomplete="off"
        *ngIf="searchVisible"
        [disabled]="disabled"
        [(ngModel)]="searchString"
        (click)="noBubble($event); presentDropdown()"
        (ngModelChange)="inputValueChange()"
      ></ion-input>
    </div>
  </div>

  <div class="actions">
    @if (inlineClearButton) {
      <ion-button
        fill="clear"
        size="small"
        *ngIf="clearable && value?.length > 0 && !disabled"
        (click)="noBubble($event); clearAll()"
      >
        <tr-icon class="tr-icon" [icon]="icon.cancel"></tr-icon>
      </ion-button>
    }

    <ion-button fill="clear" size="small" (click)="noBubble($event); presentDropdown()">
      <tr-icon class="tr-icon arrow-down-icon" [icon]="icon.arrowDown" [size]="iconSize.small"></tr-icon>
    </ion-button>
  </div>
</section>

<ng-template #dropdownPanel>
  <frontend-dropdown-list
    [showAddTagOnlyIfNoResults]="showAddTagOnlyIfNoResults"
    [maxSelectedItems]="maxSelectedItems"
    [noItemsText]="noItemsText"
    [items]="mappedItems"
    [searchString]="searchString"
    [addTag]="addTag"
    [minWidth]="minWidth"
    [maxListHeight]="maxListHeight"
    [multiple]="multiple"
    [disabled]="disabled"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [itemsIdToLabelMap]="itemsIdToLabelMap"
    [itemsIdToStateMap]="itemsIdToStateMap"
    [selectSingleItem]="selectSingleItem"
    [checkboxChange]="checkboxChange"
    [addNewItem]="addNewItem"
    [inverted]="isInverted"
    [value]="value"
    [plainValues]="plainValues"
    [searchFieldValue]="searchField?.value"
    (listContentInit)="listContentRef = $event"
    (displayItemsChange)="displayItems = $event"
  ></frontend-dropdown-list>
</ng-template>

<ion-modal
  id="example-modal"
  #modal
  [isOpen]="isMobilePopoverOpen"
  [showBackdrop]="true"
  [keepContentsMounted]="false"
  [animated]="false"
  [keyboardClose]="false"
  (willPresent)="resetFocus()"
  (didDismiss)="searchString = ''; isMobilePopoverOpen = false"
>
  <ng-template>
    <div class="wrapper">
      <div #listRef class="pb-3">
        <div class="d-flex align-content-center justify-content-between">
          <b class="mobile-placeholder">{{ placeholder }}</b>
          <tr-icon [icon]="icon.cancel" classes="close-btn-icon" (click)="isMobilePopoverOpen = false"></tr-icon>
        </div>

        <ion-searchbar
          #mobileSearchBar
          [(ngModel)]="searchString"
          (ngModelChange)="inputValueChange()"
          (ionClear)="searchString = ''; filterDisplayItems()"
          mode="ios"
          placeholder="Search"
        ></ion-searchbar>

        <div class="overflow-y-scroll">
          <frontend-dropdown-list
            [showAddTagOnlyIfNoResults]="showAddTagOnlyIfNoResults"
            [maxSelectedItems]="maxSelectedItems"
            [noItemsText]="noItemsText"
            [items]="mappedItems"
            [searchString]="searchString"
            [addTag]="addTag"
            [minWidth]="minWidth"
            [maxListHeight]="maxListHeight"
            [multiple]="multiple"
            [disabled]="disabled"
            [bindLabel]="bindLabel"
            [bindValue]="bindValue"
            [itemsIdToLabelMap]="itemsIdToLabelMap"
            [itemsIdToStateMap]="itemsIdToStateMap"
            [selectSingleItem]="selectSingleItem"
            [checkboxChange]="checkboxChange"
            [addNewItem]="addNewItem"
            [inverted]="isInverted"
            [value]="value"
            [searchFieldValue]="searchField?.value"
            [showBorder]="false"
            (listContentInit)="listContentRef = $event"
            (displayItemsChange)="displayItems = $event"
          ></frontend-dropdown-list>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>
